import React, { useContext, useState, useEffect } from 'react';

import { Button, Form, FormGroup, Input, Label, Modal, ModalHeader, ModalBody } from 'reactstrap';
import AxiosContext from '../../helpers/AxiosContext';
import notify from '../../helpers/toast-notify';
import AcceptedIssuesEvidenceManager from './AcceptedIssuesEvidenceManager';

import { Controller, useForm } from 'react-hook-form';

function AcceptedIssuesReasonModal(props) {
    const axios_api = useContext(AxiosContext).axios;

    const { showModal, setShowModal, accepted, issueType, generalIssue, selectedIds, setAccepted, toggleAcceptedIssue } = props;

    const [fileNumber, setFileNumber] = useState(1);
    const [evidenceFiles, setEvidenceFiles] = useState(['']);

    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const addFile = (pos, filename) => {
        let evidences = [...evidenceFiles];
        evidences[pos] = filename;
        setEvidenceFiles(evidences);
    };

    useEffect(() => {
        let files = [...evidenceFiles];
        files[fileNumber - 1] = '';
        setEvidenceFiles(files);
    }, [fileNumber]);

    const saveEntry = async (values) => {
        let formData = new FormData();

        evidenceFiles.forEach((file) => {
            console.log(file);
            formData.append('evidences', file);
        });

        formData.append('issue_type', issueType);
        formData.append('accepted', !accepted);
        formData.append('ids', JSON.stringify(selectedIds));
        formData.append('generalIssueId', generalIssue?.id);
        formData.append('reason', values?.reason);

        let res = await axios_api
            .post('scan/issue/set-accepted', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            })
            .catch((e) => {
                console.log(e);
            });
        if (res) {
            if (toggleAcceptedIssue) {
                toggleAcceptedIssue(selectedIds);
            }
            if (setAccepted) {
                setAccepted(!accepted);
            }
            
            notify(accepted ? 'Issue successfully unset as accepted' : 'Issue successfully set as accepted');
            setShowModal(!showModal);
        }
    };

    return (
        <Modal
            isOpen={showModal}
            toggle={() => {
                setShowModal(!showModal);
            }}>
            <ModalHeader
                className="custom-modal-header"
                toggle={() => {
                    setShowModal(!showModal);
                }}>
                <span>{'Issue Resolved'}</span>
            </ModalHeader>
            <ModalBody>
                <Form
                    onSubmit={handleSubmit(saveEntry)}
                    className="needs-validation mt-2"
                    noValidate
                    name="chat-form"
                    id="chat-form">
                    <FormGroup>
                        <Label for="reason">
                            {accepted ? 'Why should this issue be unaccepted?' : 'Why should this issue be accepted?'}
                        </Label>
                        <Controller
                            name="reason"
                            control={control}
                            rules={{
                                required: {
                                    value: true,
                                    message: 'Reason cannot be empty',
                                },
                            }}
                            render={({ field }) => (
                                <Input {...field} type="textarea" id="reason" invalid={!!errors?.reason} />
                            )}
                        />
                        <div className="text-danger">{errors?.reason?.message}</div>
                    </FormGroup>

                    <div>
                        {[...Array(fileNumber).keys()].map((key) => {
                            return <AcceptedIssuesEvidenceManager key={key} pos={key} setFiles={addFile} />;
                        })}
                    </div>

                    <Button color="primary" block>
                        Submit
                    </Button>
                </Form>
            </ModalBody>
        </Modal>
    );
}

export default React.memo(AcceptedIssuesReasonModal);
